import { Tracking } from './tracking'
import { Video } from './video'
import { Chatbot } from './chatbot'

export const throttle = function (callback, threshold, scope) {
  let last = 0

  let timer

  if (typeof threshold === 'undefined') {
    threshold = 250
  }

  return function () {
    const context = scope || this

    const now = +new Date()

    const args = arguments

    const run = function () {
      last = now
      callback.apply(context, args)
    }

    if (last && now < last + threshold) {
      window.clearTimeout(timer)
      timer = window.setTimeout(run, threshold)
    } else {
      run()
    }
  }
}

export const extend = function () {
  const extended = {}
  let deep = false
  let i = 0
  const length = arguments.length

  // Check if a deep merge
  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0]
    i++
  }

  // Merge the object into the extended object
  const merge = function (obj) {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop])
        } else {
          extended[prop] = obj[prop]
        }
      }
    }
  }

  // Loop through each object and conduct a merge
  for (;i < length; i++) {
    const obj = arguments[i]
    merge(obj)
  }

  return extended
}

export const escape = function (string) {
  return string.replace(/([.*+?^${}()|[\]/\\])/g, '\\$1')
}

export const $ = function (selector, parent) {
  return (parent || document).querySelector(selector)
}

export const $$ = function (selector, parent) {
  return [...(parent || document).querySelectorAll(selector)]
}

export const addEvent = function (element, type, handler) {
  const customEvent = new Event(type)

  element.addEventListener(type, handler)

  return customEvent
}

export const getAnchor = function () {
  const currentUrl = document.URL
  const urlParts = currentUrl.split('#')

  return (urlParts.length > 1) ? urlParts[1] : null
}

export const initCookiebotOverlayHandler = function () {
  window.addEventListener('CookiebotOnAccept', function (e) {
    const tracking = new Tracking()
    tracking.init()

    const video = new Video()
    video.init()
    video.checkCookie()

    const chatbot = new Chatbot()
    chatbot.init()
  }, false)

  window.addEventListener('CookiebotOnDecline', function (e) {
    const tracking = new Tracking()
    tracking.init()

    const video = new Video()
    video.init()
    video.checkCookie()

    const chatbot = new Chatbot()
    chatbot.init()
  }, false)

  if (document.getElementsByClassName('button-open-cookie-settings').length) {
    Array.from(document.getElementsByClassName('button-open-cookie-settings')).forEach((el) => {
      // Do stuff here
      el.addEventListener('click', function (event) {
        event.preventDefault()
        Cookiebot.show()
      })
    })
  }
}

export const hasParentsClass = function (element, classname) {
  if (element.classList.contains(classname)) {
    return true
  }

  return element.parentElement && hasParentsClass(element.parentElement, classname)
}

export const hasParentsDataset = function (element, dataName) {
  if (element.dataset[dataName]) {
    return true
  }

  return element.parentElement && hasParentsDataset(element.parentElement, dataName)
}
